import { Button, InputPicker, Input, Popover, Whisper } from 'rsuite';
import styles from './Item.module.css';
//import PartSearch from '../../../PartSearch/PartSearch';
import { useContext, useState } from 'react';
//import { InvoiceContext } from '../../../../../../Invoices';
import { getAccessLevel } from '../../../../../../../helperFunctions';

function Item({ item, rowIndex, readonly, onDelete, onChange, formMode }) {
	//const Invoice = useContext(InvoiceContext);

	const inputHandler = (e, rowIndex, colIndex) => {
		//const property = e.target.id;
		//const key = e.target.key;
		onChange(e, rowIndex, colIndex);
		//onChange(property, v);
	};

	// const isDisabled = form?.qty === '0';

	// const manufacturerName = form?.manufacturerName ? form.manufacturerName : '';
	// const tooltip = <Popover>{`${form?.partNo} ${manufacturerName} ${form?.catalogue}`}</Popover>;
	//

	// 	const itemsWidth = ['105px', '200px', '70px', '70px', '105px', '110px', '40px'];
	// let itemsWidth = ['105px', '200px', '70px', '70px', '105px', '110px', '40px'];
	// if (formMode != 'create') {
	// 	const aveWidth = Math.round(890 / item.length) - 40;
	// 	itemsWidth = Array(item.length).fill(aveWidth);
	// }

	const aveWidth = Math.round(900 / item.length) - 10;
	let itemsWidth = Array(item.length).fill(aveWidth);

	return (
		<>
			<div key={rowIndex} className={`${styles.container}`}>
				{item.map((value, colIndex) => (
					<Input
						id={`${colIndex}`}
						key={`${rowIndex}-${colIndex}`}
						readOnly={readonly}
						onChange={(e) => {
							inputHandler(e, rowIndex, colIndex);
						}}
						value={value}
						placeholder='' //{`Column ${colIndex + 1}`}
						style={{ width: itemsWidth[colIndex] }}
					/>
				))}
			</div>
		</>
	);
}

export default Item;

export const DeleteIcon = ({ onDelete }) => {
	return (
		<>
			<Button onClick={onDelete} appearance='subtle' style={{ width: 42 }}>
				<svg
					// onClick={onDelete}
					xmlns='http://www.w3.org/2000/svg'
					width='20'
					height='20'
					viewBox='0 0 20 20'
					fill='none'
				>
					<path d='M15 5L5 15' stroke='#EF4B4B' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
					<path
						d='M15 5L5 15'
						stroke='#EF4B4B'
						strokeOpacity='0.5'
						strokeWidth='2'
						strokeLinecap='round'
						strokeLinejoin='round'
					/>
					<path d='M5 5L15 15' stroke='#EF4B4B' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
					<path
						d='M5 5L15 15'
						stroke='#EF4B4B'
						strokeOpacity='0.5'
						strokeWidth='1.5'
						strokeLinecap='round'
						strokeLinejoin='round'
					/>
				</svg>
			</Button>
		</>
	);
};
